import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { height } from 'styled-system';
export var WidthWrapper = styled(Box).withConfig({
  displayName: "layout__WidthWrapper",
  componentId: "sc-n7otxg-0"
})(["", " width:100%;max-width:1200px;margin:0 auto;"], height);